import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetNewsListAppendSucceed, EGetNewsListActionType } from './types';
import { INewsList } from '../../../types/newsList';

export const getNewsListAppendSucceed: (data: INewsList) => TGetNewsListAppendSucceed = actionGenerator<
  EGetNewsListActionType.AppendSucceed,
  INewsList
>(EGetNewsListActionType.AppendSucceed);
